import { bankid } from "@wayke-se/ecom";
export default (data, callback) => {
    const request = bankid
        .newCollectRequest()
        .withOrderRef(data.orderRef)
        .build();
    bankid
        .collect(request)
        .then((response) => {
        callback(response);
    })
        .catch(() => {
        callback(null);
    });
};
